<template>
    <div>

      <report-window endpoint="/reports/tickets_detail" :fields="fields" :title="title" :headers="headers"
      :templates="templates" :columnsClasses="columnsClasses"></report-window>

    </div>
</template>

<script>
import '@/css/app.css';

import ReportWindow from '@/components/tools/ReportWindow'
import { mapState } from 'vuex';
var moment = require('moment');
export default {
  name: 'ticketsdetail',
  components: {

    ReportWindow,
  },
  computed: {
    ...mapState({
        user: state => state.user,
    }),
  },
  data () {
    return {
        fields: [
        {name: 'FromDate', editor: 'date', label: 'Desde', defValue: moment(new Date()).format("YYYY-MM-DD")
            , required: true, columns: 1},
        {name: 'ToDate', editor: 'date', label: 'Hasta', defValue:  moment(new Date()).format("YYYY-MM-DD")
            , required: true, columns: 1},
        {name: 'Mode', label: 'Expandir', editor: 'select', defValue: '0',
            options: [
                {value: '0', label: 'No'},
                {value: '1', label: 'Si'},
                ]},
         ],
        title: 'Detalle de Tickets',
        headers: {Amount: 'Total', Fare: 'Tarifa', DepartureStation: 'Origen', ArrivalStation: 'Destino'},
        templates: [
            {name: 'Amount', callback (row) {return app.numberFormat(parseFloat(row.Amount));}},
        ],
        columnsClasses: {Amount: 'text-right'},

    }
  },
}
</script>

